import { Stack, Tooltip, Typography } from '@mui/material';
import { TruncatedText } from 'component/MarketPlace/Typography/Typography.style';
import React from 'react';
import { ProductCardProps } from '..';
import { NOT_APPLICABLE } from '../../../../constants/originalState';

type CardDescriptionProps = Pick<
  ProductCardProps,
  'product' | 'maxDescLines' | 'showSpecifications' | 'locale'
>;

const CardDescription = (props: CardDescriptionProps) => {
  const { product, maxDescLines, showSpecifications, locale } = props;

  if (!showSpecifications) {
    return (
      <TruncatedText
        maxlines={maxDescLines}
        variant="body2"
        color="text.secondary"
        letterSpacing={0.17}
        mt={1}
      >
        {product.description_text}
      </TruncatedText>
    );
  }

  const specifications: Array<{ label: string; value: string }> = [
    { label: locale?.productDetail?.brand, value: product?.specifications?.General?.brand },
    { label: locale?.productDetail?.type, value: product?.category[0]?.name },
    { label: locale?.productDetail?.graphicCard, value: product?.specifications?.Graphic?.['specifications.graphic_processor'] },
    { label: locale?.productDetail?.language, value: product?.language },
  ];

  const formatValue = (value: string | null) => {
    const isNull = !value || value === 'null';
    return isNull ? NOT_APPLICABLE : value;
  };

  return (
    <Stack spacing={1} mt={2}>
      {specifications.map((spec, index) => (
        <Stack key={index} direction="row" spacing={1}>
          <Typography variant="body2" color="text.secondary" fontWeight={700} flexShrink={0}>
            {spec.label}
          </Typography>
          <Tooltip title={spec.value} arrow>
            <TruncatedText variant="body2" color="text.secondary" maxlines={1}>
              {formatValue(spec.value)}
            </TruncatedText>
          </Tooltip>
        </Stack>
      ))}
    </Stack>
  );
};

export default CardDescription;
